import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import {
    createRequest,
    getEmployeeRequests,
    deleteRequest,
} from "../../../redux/ptoRequests/ptoRequestsActions";
import moment from "moment";
import { Grid } from "@material-ui/core";

import PtoCalendar from "./PtoCalendar";
import PtoDialog from "./PtoDialog";

const useStyles = makeStyles(theme => ({
    cont: {
        width: "100%",
    },
}));

const PtoRequest = () => {
    const currentUser = useSelector(state => state.users.currentUser);
    const employeeRequests = useSelector(
        state => state.employeeRequests.employeeRequests
    );
    const [open, setOpen] = useState(false);
    const [dialogObj, setDialogObj] = useState({});
    const dispatch = useDispatch();
    const [updated, setUpdated] = useState(false);

    const [reqObj, setReqObj] = useState({
        userId: currentUser.id,
        startDate: "",
        endDate: "",
        requestType: "",
        partialHours:"",
        requestStatus: "",
        userComments: "",
        managerComments: "",
    });

    const handleOpen = event =>
        event || reqObj.startDate ? setOpen(true) : null;

    const bindRequests = () => dispatch(getEmployeeRequests(currentUser.id));

    useEffect(() => {
        bindRequests();
    }, [updated]);

    const handleSubmit = async () => {
        await dispatch(createRequest({ ...reqObj, requestStatus: "Pending" }));
        handleUpdate();
        handleClose();
    };

    const handleUpdate = () => setUpdated(!updated);

    useEffect(() => {
        handleOpen();
    }, [reqObj]);

    const getUserName = id =>
        `${currentUser.firstName} ${currentUser.lastName}`;

    const getEvents = () => {
        let arr = [];
        employeeRequests.map(request => {
            arr.push({
                requestId: request.id,
                userId: request.userId,
                requestTitle:((request.partialHours||0)>0)&&((request.partialHours||0)<8)?`${getUserName()} partial pto request`:`${getUserName()} pto request`,
                usersName: getUserName() || "N/A",
                allDay: true,
                start: request.startDate,
                end: request.endDate+" "+"01:00:00",
                managerId: request.managerId,
                requestType: request.requestType,
                userComments: request.userComments,
                managerComment: request.managerComments,
                daysRequested: request.daysRequested,
                requestStatus: request.requestStatus,
                partialHours: request.partialHours,
            });
        });
        return arr;
    };

    const events = getEvents();

    const handleClose = () => {
        setOpen(false);
        setReqObj({
            ...reqObj,
            startDate: "",
            endDate: "",
            requestStatus: "",
            requestType: "",
            userComments: "",
            partialHours:""
        });
        setDialogObj({});
    };

    const getCalendarDates = (startDate, endDate) => {
        let formattedStart = moment(startDate).format("MM-DD-YYYY");
        let formattedEnd = moment(endDate).format("MM-DD-YYYY");

        setReqObj({
            ...reqObj,
            startDate: formattedStart,
            endDate: formattedEnd,
        });
    };

    const handleDelete = async () => {
        await dispatch(deleteRequest(dialogObj.requestId, currentUser.id));
        handleUpdate();
        handleClose();
    };

    const getRequestType = requestType => setReqObj({ ...reqObj, requestType });
    const getDialogObj = obj => setDialogObj(obj);
    const getDialogValues = e =>
        setReqObj({ ...reqObj, [e.target.name]: e.target.value });
    const classes = useStyles();

    return (
        <>
            <h1>Request time off</h1>
            <Grid container justify="center" alignItems="center">
                <PtoCalendar
                    getCalendarDates={getCalendarDates}
                    open={open}
                    handleOpen={handleOpen}
                    getDialogObj={getDialogObj}
                    events={events || []}
                />

                <PtoDialog
                    reqObj={reqObj}
                    getDialogObj={getDialogObj}
                    dialogObj={dialogObj}
                    open={open}
                    handleOpen={handleOpen}
                    onClose={handleClose}
                    getRequestType={getRequestType}
                    getDialogValues={getDialogValues}
                    handleSubmit={handleSubmit}
                    handleDelete={handleDelete}
                />
            </Grid>
        </>
    );
};

export default PtoRequest;
